<template>
  <div class="layouts-our-assets-content" id="identidade-visual-nossos-elementos-visuais" data-search-anchor>
    <div class="layouts-title-style-wrapper">
      <h1 class="layouts-our-assets-title-span">{{ layoutsOurAssetsTitleSpan }}</h1>
      <h1 class="layouts-our-assets-title">{{ layoutsOurAssetsTitle }}</h1>
    </div>
    <div class="layouts-description-style-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-our-assets-description">{{ layoutsOurAssetsDescription }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-our-assets-description">{{ layoutsOurAssetsDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-our-assets-description">{{ layoutsOurAssetsDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-our-assets-description">{{ layoutsOurAssetsDescription3 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="layouts-our-assets-description">{{ layoutsOurAssetsDescription4 }}</p>
      </div>
    </div>
    <div
      class="layouts-our-assets-card-item"
      :style="{ backgroundImage: `url(${layoutsOurAssetsImageSrc})` }"
    ></div>
    <div class="button-layouts-wrapper">
      <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar Painel da Marca"
      />      
     
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import IconCheck from '@/assets/icons/IconCheck.vue'

@Component({
  components: {
    IconCheck    
  }
})
export default class LayoutsOurAssetsSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Painel%20da%20Marca/Painel%20da%20Marca.pdf'

  get layoutsOurAssetsTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get layoutsOurAssetsTitle(): string {
    return this.getElementText(2, 0)
  }

  get layoutsOurAssetsDescription(): string {
    return this.getElementText(2, 1)
  }

  get layoutsOurAssetsDescription1(): string {
    return this.getElementText(2, 2)
  }

  get layoutsOurAssetsDescription2(): string {
    return this.getElementText(2, 3)
  }

  get layoutsOurAssetsDescription3(): string {
    return this.getElementText(2, 4)
  }

  get layoutsOurAssetsDescription4(): string {
    return this.getElementText(2, 5)
  }

  get layoutsOurAssetsImageSrc(): string {
    return this.getElementMedia(2, 6)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layouts-our-assets-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.layouts-title-style-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding: 6.25rem 0rem 2rem 0rem;  
}

.layouts-our-assets-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  
  color: #b3b3b3;
}

.layouts-our-assets-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.layouts-description-style-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;  
}

.layouts-our-assets-description {
  font-size: 25px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 374px;
}

.layouts-our-assets-card-item {
  position: relative;  
  max-width: 1032px;
  width: 100%;
  height: 705px;
  background-repeat: no-repeat;
  background-size: contain;
}

.button-layouts-wrapper {
  display: flex;
  align-items: center;  
  padding-top: 2rem;
}
</style>
